// Unsigned upload of any file (pdf, doc, image...) to Cloudinary as a raw
// asset, returning its public url. Uploads straight from the browser, so it
// avoids the function body size limit.
export const uploadRaw = async (file, folder) => {
  if (!file) throw new Error('uploadRaw: file not provided')

  const fd = new FormData()
  fd.append('upload_preset', 'baicr6sd')
  fd.append('file', file)
  if (folder) fd.append('folder', folder)
  const r = await fetch('https://api.cloudinary.com/v1_1/vttc/raw/upload', {
    method: 'post',
    body: fd,
  }).then(x => x.json())
  return r.secure_url || r.url
}
